module.exports = __webpack_public_path__ + "img/prev-maintenance-2.5b9b7c4c.jpg";